import { SAVE_PHONE_OTP } from "../actions/otpActions"

const initState = {
  phone: "",
}

const otpReducer = (state = initState, action) => {
  if (action.type === SAVE_PHONE_OTP) {
    return {
      ...state,
      phone: action.payload,
    }
  }

  return state
}

export default otpReducer
